export default {"src":"/_next/static/media/pumpsIconWhite.c1d51551.svg","height":70,"width":71};